import React from 'react';
import { services } from '../mock';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ServicesPage = () => {
  return (
    <div>
      {/* Header Section */}
      <section className="section-padding">
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '24px', fontSize: '48px' }}>
            Services
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px' }}>
            Discover the transformative services offered at Get Lucid. Each modality is designed to support your unique journey toward wholeness, clarity, and awakening.
          </p>
        </div>
      </section>

      {/* Services List */}
      <section style={{ paddingBottom: '120px' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
            gap: '32px'
          }}>
            {services.map((service) => (
              <div key={service.id} style={{
                background: 'var(--bg-secondary)',
                borderRadius: '0px',
                padding: '40px',
                cursor: 'pointer'
              }} className="hover-lift">
                <h2 className="heading-2" style={{ marginBottom: '16px' }}>
                  {service.title}
                </h2>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
                  {service.shortDescription}
                </p>
                <Link
                  to={`/services/${service.id}`}
                  style={{
                    color: 'var(--interactive-base)',
                    textDecoration: 'none',
                    fontSize: '14px',
                    fontWeight: 500,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  Learn More <ArrowRight size={14} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
